import React, { createContext, useState, useEffect } from "react";

export const ThemeContext = createContext(); // Named export

const ThemeProvider = ({ children }) => {
  // Load all users
  const storedUsers = JSON.parse(localStorage.getItem("users")) || [];

  // Load current logged-in info
  const loggedInInfo = JSON.parse(localStorage.getItem("userLoggedin")) || null;

  // Find the logged-in user
  let currentUser = null;
  if (loggedInInfo) {
    currentUser = storedUsers.find(
      (u) =>
        u.userId === loggedInInfo.login ||
        u.email === loggedInInfo.login ||
        u.mobile === loggedInInfo.login
    );
  }

  // Theme: take from logged-in user if available
  const initialTheme = currentUser?.theme || "shinyBlack";

  const [theme, setTheme] = useState(initialTheme);

  // Keep logged-in user theme in sync
  useEffect(() => {
    if (!loggedInInfo) return;

    const updatedUsers = storedUsers.map((u) =>
      (u.userId === loggedInInfo.login ||
       u.email === loggedInInfo.login ||
       u.mobile === loggedInInfo.login)
        ? { ...u, theme }
        : u
    );

    localStorage.setItem("users", JSON.stringify(updatedUsers));
  }, [theme, loggedInInfo]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeProvider;
